import dayjs, { type Dayjs } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

export const useDates = () => {
	function formatDate(date: Dayjs, format: string) {
		return date.format(format);
	}

	return { formatDate };
};
